import { MoreHorizontalIcon } from 'lucide-react'

import { Button } from '@/components/button/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/dropdown-menu/dropdown-menu'

import { type ResMember } from '@/lib/queries/business/v1/types'
import { cn } from '@/lib/utils'

import { RemoveConfirmDialog } from './remove-confirm-dialog/remove-confim-dialog'
import { useToolsMenu } from './use-tools-menu'

export interface ToolsMenuProps {
  memberData: ResMember
}

export const ToolsMenu = ({ memberData }: ToolsMenuProps) => {
  const {
    isOpenRemoveConfirmDialog,
    isPendingRemove,
    handleClickResendMenuItem,
    handleClickRemoveMenuItem,
    handleChangeRemoveConfigDialogOpen,
    handleClickCancelButton,
    handleClickRemoveButton,
  } = useToolsMenu()

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className={cn('h-8 w-8')}>
            <MoreHorizontalIcon size={16} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={() => handleClickResendMenuItem(memberData)}>Resend invite</DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleClickRemoveMenuItem}>Remove</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {/* dialog */}
      {isOpenRemoveConfirmDialog && (
        <RemoveConfirmDialog
          memberData={memberData}
          isPendingRemove={isPendingRemove}
          onOpenChange={handleChangeRemoveConfigDialogOpen}
          onClickCancelButton={handleClickCancelButton}
          onClickRemoveButton={handleClickRemoveButton}
        />
      )}
    </>
  )
}
